import { render, staticRenderFns } from "./EditBankAccount.vue?vue&type=template&id=4120aee4&scoped=true&"
import script from "./EditBankAccount.vue?vue&type=script&lang=js&"
export * from "./EditBankAccount.vue?vue&type=script&lang=js&"
import style0 from "./EditBankAccount.vue?vue&type=style&index=0&id=4120aee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4120aee4",
  null
  
)

export default component.exports